import type { SVGProps } from 'react';
const SvgFormatLineSpacing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#format_line_spacing_svg__a)">
      <path
        fill="currentColor"
        d="M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7Zm4-2v2h12V5H10Zm0 14h12v-2H10v2Zm0-6h12v-2H10v2Z"
      />
    </g>
    <defs>
      <clipPath id="format_line_spacing_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFormatLineSpacing;
